// Importing the LOADER action type
import { LOADER } from "../Actions/ActionTypes";

// Reducer function to manage the loader state
export default (state = false, action = {}) => {
  // Check if the action type is LOADER
  if (action.type === LOADER) {
    return action.data; // Update the state with the loader data
  }
  return state; // Return the current state by default
};
